import { HttpClient } from '@packages/shared/core/common/services';
import { ApiPathAskGateway } from '@packages/shared/core/common/constants/apiPaths';
import { ZodiacTypes } from '@packages/shared/core/zodiac/entities';
import { ErrorMonitoringService } from '@packages/shared/core/common/services/errorMonitoring';
import { normalizeError } from '@packages/shared/core/common/utils/errors';
import { transformLocaleToLanguageCode } from '@packages/shared/core/common/utils/locale/transformLocaleToLanguageCode';
import { getCurrentUtcOffsetInSeconds } from '@packages/shared/core/common/utils/time/getCurrentUtcOffsetInSeconds';
import { mapDailyHoroscopeDtoToEntity } from '../mappers';
import { DailyHoroscope } from '../entities';
import { DAILY_HOROSCOPE_MONITORING_ERROR_REASON_TAG, DAILY_HOROSCOPE_PROMPT_FILE_NAME_PARAM } from '../constants';
import { DailyHoroscopeResponseTypeDto } from './dto';

export class HoroscopeService {
  private readonly locale: string;

  constructor(
    private readonly httpClient: HttpClient,
    public errorMonitoringService: ErrorMonitoringService,
    domainLocale: string,
  ) {
    this.locale = transformLocaleToLanguageCode(domainLocale);
  }

  async getDailyHoroscope(zodiac: ZodiacTypes): Promise<DailyHoroscope> {
    try {
      const { data: horoscope } = await this.httpClient.get<DailyHoroscopeResponseTypeDto>(
        ApiPathAskGateway.HOROSCOPE_ZODIAC,
        {
          params: {
            zodiac,
            periods: ['today'],
            timezone: getCurrentUtcOffsetInSeconds(),
            prompt_file_name: DAILY_HOROSCOPE_PROMPT_FILE_NAME_PARAM,
          },
          headers: {
            locale: this.locale,
          },
        },
      );

      return mapDailyHoroscopeDtoToEntity(horoscope);
    } catch (err) {
      const error = normalizeError(err);
      this.errorMonitoringService.captureError(error, {
        tags: {
          error_message: error.message,
          error_reason: DAILY_HOROSCOPE_MONITORING_ERROR_REASON_TAG,
        },
      });
      throw error;
    }
  }
}
